import { createLucideIcon } from 'lucide-react';
export const Location = createLucideIcon('location', [
  [
    'path',
    {
      d: 'M15.5 19.5L21 17.5V12.5',
      key: '1qrcw2',
    },
  ],
  [
    'path',
    {
      d: 'M15.5 19.5V16.5',
      key: 'hj0jdd',
    },
  ],
  [
    'path',
    {
      d: 'M19.3286 7.33333C19.2203 5.49557 17.707 4 15.8673 4C14.0277 4 12.6666 5.49238 12.6667 7.33333C12.6667 9.83333 16.1449 14 16.1449 14C16.1449 14 19.4758 9.83333 19.3286 7.33333Z',
      key: 'h5570o',
    },
  ],
  [
    'path',
    {
      d: 'M9 17.5L15.5 19.5',
      key: '205zub',
    },
  ],
  [
    'path',
    {
      d: 'M9 4L10.5 4.5',
      key: '14l0yt',
    },
  ],
  [
    'path',
    {
      d: 'M9 4L3 7V20.5L9 17.5',
      key: '1uosr7',
    },
  ],
  [
    'path',
    {
      d: 'M9 4V17.5',
      key: 'pa14sx',
    },
  ],
  [
    'circle',
    {
      cx: '16',
      cy: '7.6111',
      r: '0.833333',
      fill: 'var(--contrast)',
      key: 's42mv4',
    },
  ],
]);
